// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"f7ab5323","25":"05e6b5fb","60":"70fe4834","173":"3f0e7f65","425":"9a5abca2","758":"6ad7dbf2","871":"5a754984","872":"46fe3861"}[chunkId] + ".chunk.js";
};